import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import STRINGS from "../Constants/Strings";
import AppConstants from "../Constants/AppConstants";
import * as ROUTES from "../Constants/Routes";
import { getProductInfoFromCurrentDoximProducts } from "../Utils/CommonUtilities";
import { applicationStillInVault } from "../Utils/LogicUtilities";
import ApplicationDetails from "./ApplicationDetails";

const ApplicationList = ({
  applicationList = [],
  productVault = [],
  productList = [],
  proceedWithApplication,
  switchBanking,
  history,
  targetApplicationId = null,
  doDeleteApplication,
  doUpdateProductToVault,
  refreshMemberDetails,
  doAddDocument,
  doDeleteDocument,
  doGetDocumentList,
  doGetDocument,
  doGetApplicationProperty,
  selectedMember,
  applicant,
  employmentAndIncomeReducer,
  complianceReducer,
  doGetProductInformation,
  finInfo,
  doGetApplicationNotes,
  doUpdateApplicationNotesReview,
  doConfirmApp,
  doGetProductFromVault,
  doGetVault,
}) => {
  const [selectedApplication, setSelectedApplication] = useState(null);
  const [
    selectedApplicationProperty,
    setSelectedApplicationProperty,
  ] = useState(null);
  const [selectedProductInfo, setSelectedProductInfo] = useState(null);
  const [showDetails, setShowDetails] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [applicationToDelete, setApplicationToDelete] = useState(null);
  const [cancelButtonHover, setCancelButtonHover] = useState(false);
  const [removeButtonHover, setRemoveButtonHover] = useState(false);

  // Auto-select application if targetApplicationId is provided
  useEffect(() => {
    if (
      targetApplicationId &&
      (applicationList.length > 0 || productVault.length > 0)
    ) {
      let targetApp = productVault.find(
        (app) =>
          app.id === targetApplicationId ||
          app.applicationId === targetApplicationId
      );
      if (targetApp) targetApp.inProgress = true;

      const listApp = applicationList.find(
        (app) =>
          app.id === targetApplicationId ||
          app.applicationId === targetApplicationId
      );
      if (listApp) {
        targetApp = { ...targetApp, ...listApp };
      }

      if (targetApp) {
        setSelectedApplication(targetApp);
        doGetApplicationProperty(
          { applicationId: targetApplicationId },
          (applicationProperty) => {
            setSelectedApplicationProperty(applicationProperty);
            const productInfo = getProductInfoFromCurrentDoximProducts(
              applicationProperty.doximProducts,
              productList
            );
            doGetProductInformation(
              targetApplicationId,
              productInfo?.type,
              productInfo?.id,
              (productInfo) => setSelectedProductInfo(productInfo.data)
            );
          }
        );
        setShowDetails(true);
      }
    }
  }, [targetApplicationId, applicationList, productVault]);

  const handleApplicationClick = (application) => {
    setSelectedApplication(application);
    doGetApplicationProperty(
      { applicationId: application.applicationId || application.id },
      (applicationProperty) => {
        setSelectedApplicationProperty(applicationProperty);
        const productInfo = getProductInfoFromCurrentDoximProducts(
          applicationProperty.doximProducts,
          productList
        );
        doGetProductInformation(
          application.applicationId || application.id,
          productInfo?.type,
          productInfo?.id,
          (productInfo) => setSelectedProductInfo(productInfo.data)
        );
      }
    );
    setShowDetails(true);
  };

  const handleBackToList = (shouldRefresh = false) => {
    setShowDetails(false);
    setSelectedApplication(null);
    if (shouldRefresh && refreshMemberDetails && selectedMember) {
      refreshMemberDetails(selectedMember);
    }
  };

  const handleDeleteClick = (application) => {
    setApplicationToDelete(application);
    setShowDeleteModal(true);
  };

  const handleCancelDelete = () => {
    setShowDeleteModal(false);
    setApplicationToDelete(null);
  };

  const handleConfirmDelete = () => {
    console.log("Deleting application:", applicationToDelete);
    const idx = productVault.findIndex((app) => app === applicationToDelete);
    if (idx > -1) {
      productVault.splice(idx, 1);
      doUpdateProductToVault(productVault, () => {
        if (applicationToDelete.applicationId) {
          doDeleteApplication(applicationToDelete.applicationId, () => {
            refreshMemberDetails(selectedMember);
            setShowDeleteModal(false);
            setApplicationToDelete(null);
          });
        } else {
          refreshMemberDetails(selectedMember);
          setShowDeleteModal(false);
          setApplicationToDelete(null);
        }
      });
    }
  };

  if (showDetails && selectedApplication) {
    return (
      <ApplicationDetails
        application={selectedApplication}
        onBack={handleBackToList}
        productList={productList}
        doAddDocument={doAddDocument}
        doDeleteDocument={doDeleteDocument}
        doGetDocumentList={doGetDocumentList}
        doGetDocument={doGetDocument}
        applicationProperty={selectedApplicationProperty}
        applicant={applicant}
        employmentAndIncomeReducer={employmentAndIncomeReducer}
        complianceReducer={complianceReducer}
        selectedProductInfo={selectedProductInfo}
        finInfo={finInfo}
        doGetApplicationNotes={doGetApplicationNotes}
        doUpdateApplicationNotesReview={doUpdateApplicationNotesReview}
        doDeleteApplication={doDeleteApplication}
        doConfirmApp={doConfirmApp}
        doGetProductFromVault={doGetProductFromVault}
        doUpdateProductToVault={doUpdateProductToVault}
        doGetVault={doGetVault}
        history={history}
        doGetApplicationProperty={doGetApplicationProperty}
      />
    );
  }

  return (
    <div>
      {/* Personal Banking - In Progress */}
      <div
        className="application-group mb-4"
        style={{
          borderRight: "1px solid #eee",
          borderLeft: "1px solid #eee",
          background: "#fff",
          borderRadius: "0.5rem",
          backgroundColor: "#f8f9fa",
          padding: "10px 15px 10px 15px",
        }}
      >
        <div className="d-flex align-items-center mb-3">
          <i
            className="fas fa-shopping-cart me-2"
            style={{ color: "#333", fontSize: "1rem", marginRight: "4px" }}
          ></i>
          <h6
            className="mb-0 fw-bold"
            style={{ color: "#333", fontSize: "1rem" }}
          >
            Personal Banking —{" "}
            {finInfo?.config?.status?.inProgress || "In Progress"}
          </h6>
        </div>
        {productVault.length === 0 && (
          <div
            className="text-center py-5"
            style={{
              borderRadius: "4px",
              color: "#6c757d",
            }}
          >
            <p className="mb-0" style={{ fontSize: "0.95rem" }}>
              No applications in 'Progress'.
            </p>
          </div>
        )}
        <div
          className="row"
          style={{ gap: "6px", paddingLeft: "8px", paddingRight: "8px" }}
        >
          {productVault?.map((application, index) => (
            <div
              key={index}
              className="col-4 mb-3 side-in-progress"
              style={{
                backgroundColor: "white",
                borderRadius: "4px",
                boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                paddingRight: "1px",
              }}
            >
              <div className="d-flex justify-content-between align-items-start">
                <div style={{ flex: 1, margin: "5px 1px 5px 5px" }}>
                  <h6
                    className="mb-2"
                    style={{
                      color: "#333",
                      fontSize: "1rem",
                      fontWeight: "600",
                    }}
                  >
                    {application.productName}
                  </h6>
                  <p
                    className="text-muted mb-0"
                    style={{ fontSize: "0.9rem", lineHeight: "1.4" }}
                  >
                    {application.productDescription || ""}
                  </p>
                </div>
                <div
                  className="d-flex align-items-start"
                  style={{ marginTop: "1px", gap: "8px" }}
                >
                  <i
                    className="fas fa-trash-alt"
                    style={{
                      color: "#dc3545",
                      fontSize: "0.9rem",
                      cursor: "pointer",
                    }}
                    onClick={() => handleDeleteClick(application)}
                  ></i>
                  {application.applicationId && (
                    <i
                      className="fas fa-external-link-alt"
                      style={{
                        color: "red",
                        fontSize: "0.9rem",
                        cursor: "pointer",
                      }}
                      onClick={() =>
                        handleApplicationClick({
                          ...application,
                          inProgress: true,
                        })
                      }
                    ></i>
                  )}
                </div>
              </div>
            </div>
          ))}
          {productVault.length > 0 && (
            <div className="col-12 mb-3">
              <button
                type="button"
                className="btn"
                style={{
                  backgroundColor: "#17a2b8",
                  color: "white",
                  border: "none",
                  borderRadius: "4px",
                  fontSize: "0.75rem",
                  fontWeight: "600",
                  padding: "6px 12px",
                  textTransform: "uppercase",
                  marginTop: "1em",
                }}
                onClick={() =>
                  productVault.length > 0
                    ? proceedWithApplication(AppConstants.BANKING_TYPE.PERSONAL)
                    : switchBanking(
                        AppConstants.BANKING_TYPE.PERSONAL,
                        history.push(`${ROUTES.VAULT_DASHBOARD}?marketplace`)
                      )
                }
              >
                PROCEED
              </button>
            </div>
          )}
        </div>
      </div>

      {/* Personal Banking - In Review */}
      <div
        className="application-group mb-4"
        style={{
          borderRight: "1px solid #eee",
          borderLeft: "1px solid #eee",
          background: "#fff",
          borderRadius: "0.5rem",
          backgroundColor: "#f8f9fa",
          padding: "10px 15px 10px 15px",
        }}
      >
        <div className="d-flex align-items-center mb-3">
          <i
            className="fas fa-tools me-2"
            style={{ color: "#333", fontSize: "1rem", marginRight: "4px" }}
          ></i>
          <h6
            className="mb-0 fw-bold"
            style={{ color: "#333", fontSize: "1rem" }}
          >
            Personal Banking —{" "}
            {finInfo?.config?.status?.inReview || "In Review"}
          </h6>
        </div>
        {applicationList?.filter(
          (app) =>
            app.inReview && !applicationStillInVault(app.id, productVault)
        ).length === 0 && (
          <div
            className="text-center py-5"
            style={{
              borderRadius: "4px",
              color: "#6c757d",
            }}
          >
            <p className="mb-0" style={{ fontSize: "0.95rem" }}>
              No applications in 'Review'.
            </p>
          </div>
        )}
        <div
          className="row"
          style={{ gap: "6px", paddingLeft: "8px", paddingRight: "8px" }}
        >
          {applicationList
            .filter(
              (application) =>
                application.inReview &&
                !applicationStillInVault(application.id, productVault)
            )
            .map((application) => (
              <div
                id={application.id || application.applicationId}
                key={application.id || application.applicationId}
                className="col-4 mb-3 side-in-review"
                style={{
                  borderLeft: "4px solid #17a2b8",
                  backgroundColor: "white",
                  border: "1px solid #e9ecef",
                  borderRadius: "4px",
                  boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                  paddingRight: "2px",
                }}
              >
                <div className="d-flex justify-content-between align-items-start">
                  <div style={{ flex: 1, margin: "2px 2px 5px 5px" }}>
                    <h6
                      className="mb-2"
                      style={{
                        color: "#333",
                        fontSize: "1rem",
                        fontWeight: "600",
                      }}
                    >
                      {
                        getProductInfoFromCurrentDoximProducts(
                          application.doximProducts,
                          productList
                        )?.productName
                      }
                    </h6>
                    <p
                      className="text-muted mb-0"
                      style={{ fontSize: "0.9rem", lineHeight: "1.4" }}
                    >
                      {
                        getProductInfoFromCurrentDoximProducts(
                          application.doximProducts,
                          productList
                        )?.productDescription
                      }
                    </p>
                  </div>
                  <div
                    className="d-flex align-items-start"
                    style={{ marginTop: "1px" }}
                  >
                    <div
                      style={{
                        width: "24px",
                        height: "24px",
                        backgroundColor: "#e91e63",
                        borderRadius: "4px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                      }}
                      onClick={() => handleApplicationClick(application)}
                    >
                      <i
                        className="fas fa-external-link-alt"
                        style={{ color: "white", fontSize: "0.7rem" }}
                      ></i>
                    </div>
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>

      {/* Personal Banking - Pending */}
      <div
        className="application-group mb-4"
        style={{
          borderRight: "1px solid #eee",
          borderLeft: "1px solid #eee",
          background: "#fff",
          borderRadius: "0.5rem",
          backgroundColor: "#f8f9fa",
          padding: "10px 15px 10px 15px",
        }}
      >
        <div className="d-flex align-items-center mb-3">
          <i
            className="fas fa-lock me-2"
            style={{ color: "#333", fontSize: "1rem", marginRight: "4px" }}
          ></i>
          <h6
            className="mb-0 fw-bold"
            style={{ color: "#333", fontSize: "1rem" }}
          >
            Personal Banking — {finInfo?.config?.status?.pending || "Pending"}
          </h6>
        </div>
        {applicationList?.filter(
          (app) =>
            !app.inReview &&
            !app.uploadedAt &&
            !applicationStillInVault(app.id, productVault)
        ).length === 0 && (
          <div
            className="text-center py-5"
            style={{
              borderRadius: "4px",
              color: "#6c757d",
            }}
          >
            <p className="mb-0" style={{ fontSize: "0.95rem" }}>
              No applications in 'Pending'.
            </p>
          </div>
        )}
        <div
          className="row"
          style={{ gap: "6px", paddingLeft: "8px", paddingRight: "8px" }}
        >
          {applicationList
            .filter(
              (application) =>
                !application.inReview &&
                !application.uploadedAt &&
                !applicationStillInVault(application.id, productVault)
            )
            .map((application) => (
              <div
                id={application.id || application.applicationId}
                key={application.id || application.applicationId}
                className="col-4 mb-3 side-pending"
                style={{
                  borderLeft: "4px solid #17a2b8",
                  backgroundColor: "white",
                  border: "1px solid #e9ecef",
                  borderRadius: "4px",
                  boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                  paddingRight: "2px",
                }}
              >
                <div className="d-flex justify-content-between align-items-start">
                  <div style={{ flex: 1, margin: "2px 2px 5px 5px" }}>
                    <h6
                      className="mb-2"
                      style={{
                        color: "#333",
                        fontSize: "1rem",
                        fontWeight: "600",
                      }}
                    >
                      {
                        getProductInfoFromCurrentDoximProducts(
                          application.doximProducts,
                          productList
                        )?.productName
                      }
                    </h6>
                    <p
                      className="text-muted mb-0"
                      style={{ fontSize: "0.9rem", lineHeight: "1.4" }}
                    >
                      {
                        getProductInfoFromCurrentDoximProducts(
                          application.doximProducts,
                          productList
                        )?.productDescription
                      }
                    </p>
                  </div>
                  <div
                    className="d-flex align-items-start"
                    style={{ marginTop: "1px" }}
                  >
                    <div
                      style={{
                        width: "24px",
                        height: "24px",
                        backgroundColor: "#e91e63",
                        borderRadius: "4px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                      }}
                      onClick={() =>
                        handleApplicationClick({
                          ...application,
                          status: "PENDING",
                        })
                      }
                    >
                      <i
                        className="fas fa-external-link-alt"
                        style={{ color: "white", fontSize: "0.7rem" }}
                      ></i>
                    </div>
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>

      {/* Personal Banking Applications - Complete */}
      <div
        className="application-group mb-4"
        style={{
          borderRight: "1px solid #eee",
          borderLeft: "1px solid #eee",
          background: "#fff",
          borderRadius: "0.5rem",
          backgroundColor: "#f8f9fa",
          padding: "10px 15px 10px 15px",
        }}
      >
        <div className="d-flex align-items-center mb-3">
          <i
            className="fas fa-check me-2"
            style={{ color: "#333", fontSize: "1rem" }}
          ></i>
          <h6
            className="mb-0 fw-bold"
            style={{ color: "#333", fontSize: "1rem" }}
          >
            Personal Banking Applications —{" "}
            {finInfo?.config?.status?.complete || "Complete"}
          </h6>
        </div>
        {applicationList?.filter((app) => app.uploadedAt).length === 0 && (
          <div
            className="text-center py-5"
            style={{
              borderRadius: "4px",
              color: "#6c757d",
            }}
          >
            <p className="mb-0" style={{ fontSize: "0.95rem" }}>
              No applications in 'Complete'.
            </p>
          </div>
        )}
        <div
          className="row"
          style={{ gap: "6px", paddingLeft: "8px", paddingRight: "8px" }}
        >
          {applicationList
            .filter((application) => application.uploadedAt)
            .map((application) => (
              <div
                id={application.id || application.applicationId}
                key={application.id || application.applicationId}
                className="col-4 mb-3 side-in-review"
                style={{
                  borderLeft: "4px solid #17a2b8",
                  backgroundColor: "white",
                  border: "1px solid #e9ecef",
                  borderRadius: "4px",
                  boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                  paddingRight: "2px",
                }}
              >
                <div className="d-flex justify-content-between align-items-start">
                  <div style={{ flex: 1, margin: "2px 2px 5px 5px" }}>
                    <h6
                      className="mb-2"
                      style={{
                        color: "#333",
                        fontSize: "1rem",
                        fontWeight: "600",
                      }}
                    >
                      {
                        getProductInfoFromCurrentDoximProducts(
                          application.doximProducts,
                          productList
                        )?.productName
                      }
                    </h6>
                    <p
                      className="text-muted mb-0"
                      style={{ fontSize: "0.9rem", lineHeight: "1.4" }}
                    >
                      {
                        getProductInfoFromCurrentDoximProducts(
                          application.doximProducts,
                          productList
                        )?.productDescription
                      }
                    </p>
                  </div>
                  <div
                    className="d-flex align-items-start"
                    style={{ marginTop: "1px" }}
                  >
                    <div
                      style={{
                        width: "24px",
                        height: "24px",
                        backgroundColor: "#e91e63",
                        borderRadius: "4px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                      }}
                      onClick={() => handleApplicationClick(application)}
                    >
                      <i
                        className="fas fa-external-link-alt"
                        style={{ color: "white", fontSize: "0.7rem" }}
                      ></i>
                    </div>
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>

      {/* Delete Confirmation Modal */}
      {showDeleteModal && (
        <Modal
          show={showDeleteModal}
          onHide={handleCancelDelete}
          className="[ popup-modal__container ]"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header className="[ popup-modal__header ]" closeButton>
            <Modal.Title as="h5" className="d-flex align-items-center">
              <i
                className="fas fa-trash-alt mr-2"
                style={{ fontSize: "20px", color: "#333" }}
              ></i>
              {
                STRINGS.BRANCH.MEMBER_PROFILE.MEMBER_MAIN_PANEL.APPLICATIONS_TAB
                  .DELETE_PRODUCT_MODAL.TITLE
              }
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <p>
              {
                STRINGS.BRANCH.MEMBER_PROFILE.MEMBER_MAIN_PANEL.APPLICATIONS_TAB
                  .DELETE_PRODUCT_MODAL.CONFIRM_MESSAGE
              }
            </p>
          </Modal.Body>

          <Modal.Footer className="[ popup-modal-footer ] [ d-block ]">
            <div className="[ mb-3 ]">
              <button
                type="button"
                className="[ submit-btn btn ] [ w-100 ]"
                style={{
                  backgroundColor: removeButtonHover ? "#4dd4a7" : "#28c38e",
                  color: "white",
                  border: "1px solid #11637e",
                  borderRadius: "20px",
                  padding: "10px 24px",
                  fontSize: "14px",
                  fontWeight: "500",
                  transition: "background-color 0.2s ease",
                }}
                onClick={handleConfirmDelete}
                onMouseEnter={() => setRemoveButtonHover(true)}
                onMouseLeave={() => setRemoveButtonHover(false)}
              >
                {
                  STRINGS.BRANCH.MEMBER_PROFILE.MEMBER_MAIN_PANEL
                    .APPLICATIONS_TAB.DELETE_PRODUCT_MODAL.REMOVE_BUTTON
                }
              </button>
            </div>

            <div className="[ divider mb-3 d-flex align-items-center ]"></div>

            <div className="[ mb-3 częściej text-center ]">
              <span
                className="[ link ]"
                onClick={handleCancelDelete}
                role="presentation"
                style={{
                  textDecoration: "underline",
                  color: "#0090c6",
                  cursor: "pointer",
                }}
                onMouseEnter={() => setCancelButtonHover(true)}
                onMouseLeave={() => setCancelButtonHover(false)}
              >
                {
                  STRINGS.BRANCH.MEMBER_PROFILE.MEMBER_MAIN_PANEL
                    .APPLICATIONS_TAB.DELETE_PRODUCT_MODAL.CANCEL_BUTTON
                }
              </span>
            </div>
          </Modal.Footer>
        </Modal>
      )}
    </div>
  );
};

export default ApplicationList;
